import React from 'react';
function OpenCaisse() {
    return ( <>FAMILIA MARKET </> );
}

export default OpenCaisse;